import type {
  UpdateDesignerPreferencesBody,
  UpdateDesignerPreferencesResponse,
} from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { projectDetailsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useUpdateProjectDesignerPreferences(
  projectId: number,
): UseMutationResult<
  UpdateDesignerPreferencesResponse,
  Error,
  UpdateDesignerPreferencesBody
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateDesignerPreferencesBody) =>
      await apiClient
        .url(`/projects/${projectId}/designer-preferences`)
        .json(payload)
        .put()
        .json<UpdateDesignerPreferencesResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: projectDetailsKeys.detail(projectId),
      });
    },
  });
}
